import React from 'react';
import './Styles/StaggeredAnimation.css';

/**
 * Component that will apply an animation to a list of items
 * @param {*} props object, containing:
 * - items: Required. The list of items to apply the animation to. This can be anything as you'll render them yourself.
 * - renderItem: Required. A callback function that receives an item and is expected to render this item.
 * - animation: Required. The name of the animation to be applied.
 * - startHidden: Optional, default false. Whether or not to have opacity:0 set initially.
 * - easing: Optional, default ease. The easing function to use for the animation.
 * - duration: Optional, default 1. The secons the animation should last.
 * - initialDelay: Optional, default 0. The amount of delay in seconds before the first animation should start.
 * - incrementalDelay: Optional, default 0.1. The amount of animation delay between each of the items.
 *
 *
 * note ont
 */
export const StaggeredAnimation = ({
  items,
  renderItem,
  animation,
  startHidden = false,
  easing = 'ease',
  duration = 1,
  initialDelay = 0,
  incrementalDelay = 0.1
}) => {
  const renderAnimationPart = (item, index) => {
    const styles = {};
    styles.animation = `${animation} ${easing} ${duration}s forwards`;
    styles.animationDelay = `${initialDelay + incrementalDelay * (index + 1)}s`;

    const classes = startHidden ? 'Staggered--Hidden' : '';

    return (
      <div key={index} className={classes} style={styles}>
        {renderItem(item)}
      </div>
    );
  };
  return items.map(renderAnimationPart);
};
